<template>
	<div class="context-task" :class="componentClass" :id="(goal ? 'goal-task-' : 'task-')+item.id">

		<template v-if="withContent">
			<div class="context-task__item" :class="itemClass" :style="itemStyle">

				<task-color :item="item"/>

				<div class="context-task__line">
					<div class="context-task__content --task-content"
						 ref="content"
						 v-html="contentHtml"></div>
					<div v-if="attachedFiles?.length"
						 class="context-task__files">
						<div v-for="(file, fileIndex) of attachedFiles"
							 :key="'file'+fileIndex"
							 class="context-task__file">
							<div v-if="isImage(file)"
								 class="context-task__file-image"
								 @click="onClickImage(file, fileIndex)">

								<!-- todo this makes two same requests to image -->

								<v-img contain :src="file.srcThumb"
									   :lazy-src="file.srcLazy"/>
								<!--					<v-progress-circular v-else indeterminate color="grey lighten-2"/>-->
							</div>
							<span v-else-if="isPDF(file)"
								  class="context-task__file-label"
								  @click="onClickImage(file, fileIndex)">
																	<v-icon class="mr-2">{{ iconOfFile(file) }}</v-icon>
																	<span class="context-task__file-name">{{
																			file.name
																		}}</span>
																</span>
							<a v-else :href="file.src" target="_blank"
							   class="context-task__file-label d-flex align-center">
								<v-icon class="mr-2">{{
										iconOfFile(file)
									}}
								</v-icon>
								<span class="context-task__file-name">{{
										file.name
									}}</span>
							</a>
						</div>
					</div>
				</div>

				<div v-if="!isReadonly"
					 class="context-task__tools">
					<task-menu-btn :item="item" small class="--visible-on-hover"/>
				</div>
			</div>

		</template>
		<template v-else>

			<draggable
				:enabled="draggable"
				:id="goal ? 'goal-'+item.id : item.id"
				:item="item"
				:siblings="goal ? [] : selectedTasksExceptThisItem"
				:drop-zones="goal ? ['tasks-pos', 'tasks-last'] : ['tasks','tasks-pos','tasks-last','task-folders']"
				:droppable="false"
				:zone="goal ? 'goal' : 'tasks'"
				@start="onDragStart"
				@end="onDragEnd">
				<template v-slot:default="{onMouseDown}">
					<div class="context-task__item" :class="itemClass" :style="itemStyle">

						<task-color :item="item"/>

						<div class="context-task__slide" :style="slideStyle" :class="slideClass"
							 @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd">
							<div class="context-task__slide-content">

								<div class="context-task__btn-opener --mt d-none d-md-inline">
									<v-btn v-if="withTree&&hasChildren" icon small @click="onToggleChildren">
										<v-icon small>{{ openIcon }}</v-icon>
									</v-btn>
								</div>

								<div v-if="typeof index !== 'undefined'"
									 class="context-task__index grey--text caption">

									<!-- у цели процесса номер не показываем -->
									<template v-if="!goal">{{ indexText }}</template>

									<!--								<v-btn
																		v-if="!item.isFolder && !isTaskDeleted(item) && !isReadonly && hasFullAccessToTask(item)"
																		icon
																		class="icon &#45;&#45;check"
																		small
																		@click.stop.prevent="onToggleDone(item)">
																		<v-icon small>mdi-check</v-icon>
																	</v-btn>-->

								</div>

								<div class="context-task__btn-prio" :class="prioTrack ? '--track' : '--mt'">
<!--									<v-icon v-if="item.isScaffold" small class="context-task__scaffold-icon">mdi-folder-outline</v-icon>-->
									<btn-prio :item="item" :siblings="siblings" small
											  :done-item="activeChild ? activeChildItem : null"
											  :loading="!!item._pendingSwap"
											  :track="prioTrack && prioTrack.kind"
											  :track-state="prioTrack && prioTrack.state"
											  :track-last="prioTrack && prioTrack.last"
										  :track-link-prev="trackLinkPrev"
										  :track-link-next="trackLinkNext"/>
									<!--								<btn-stage v-else-if="stage" :item="item" :readonly="readonly" small/>-->
								</div>

								<div class="context-task__line" @mousedown="onMouseDownOnItem" @click="onClickItem">

									<draggable :enabled="draggable"
											   :payload="item.id"
											   :id="'dummy-droppable-folder-'+item.id"
											   zone="task-folders"
											   :accepts-zones="['tasks']"
											   :rejects-ids="rejectIds"
											   :droppable="!goal && !isTaskOfMaxLevel(item)"
											   class="context-task__droppable-folder"
											   :drop-processor="onDropOverTask">
										<component
											:is="linkComponent"
											:to="route()"
											class="context-task__link"
											draggable="false" @click="onClickComponent">
											<div class="context-task__selector"
												 @mousedown="onMouseDownOnItem" @click="onClickItem">
												<div class="d-flex align-start">

													<!--										<v-chip v-if="item.isDelayed" class="mr-2 flex-shrink-0"
																									title="Задача отложена"
																									:small="!compact"
																									:x-small="compact"
																									@click.stop.prevent="onClickDelayed">
																								<v-icon small>mdi-pause</v-icon>
																							</v-chip>-->

													<!--											<tag v-else-if="item.deferReason" class="mr-2"
																									 :title="item.deferReason"
																									 :small="!compact"
																									 :x-small="compact"
																									 active
																									 @click.native.stop.prevent="onClickDeferred">{{
																										item.deferReason
																									}}
																								</tag>-->

													<!--													<v-icon
																											v-else-if="parent.isProcess && parent.firstAssignableChildId===item.id"
																											small color="black" class="mr-2 flex-shrink-0"
																											title="Текущая задача в списке">
																											mdi-numeric-1-box
																										</v-icon>-->
													<v-btn v-if="item.isTemplate" x-small
														   class="mr-2 flex-shrink-0"
														   :color="isTaskTemplateActive(item)?COLOR_TASK_TEMPLATE:COLOR_TASK_TEMPLATE_STOPPED"
														   text
														   :title="repeatTitle"
														   @click.stop.prevent="onClickRepeatedOrTemplate">
														<v-icon x-small :left="!!repeatText">
															mdi-view-grid-plus-outline
														</v-icon>
														<span v-if="repeatText">{{
																repeatText
															}}</span>
													</v-btn>
													<div>
														<!--												<div v-if="withNavPath"
																											 class="context-task__navpath caption text-overflow grey&#45;&#45;text text&#45;&#45;lighten-1">
																											<v-icon x-small class="mr-2" color="grey">mdi-folder-outline
																											</v-icon>
																											<span v-if="withGroupName">{{ groupOfItem.name }}</span>
																											&lt;!&ndash;							<router-link v-if="groupOfItem" :to="{name: 'group', params:{groupAuth:groupOfItem.auth}}">
																																			<v-icon x-small class="ml-2">mdi-arrow-right</v-icon>
																																		</router-link>&ndash;&gt;
																											<template v-if="topicOfItem">
																												<span v-if="groupOfItem && withGroupName" class="mx-2">/</span>
																												<span>{{ topicOfItem.name }}</span>
																												&lt;!&ndash;								<router-link v-if="groupOfItem" :to="{name: 'group', params:{groupAuth:groupOfItem.auth}}">
																																					<v-icon x-small class="ml-2">mdi-arrow-right</v-icon>
																																				</router-link>&ndash;&gt;
																											</template>
																										</div>-->
														<!--													<div
																												v-if="item.totalStages>1 && item.masterTitle && item.masterTitle!==item.title"
																												class="context-task__navpath caption text-overflow grey&#45;&#45;text text&#45;&#45;lighten-1">
																												{{ item.masterTitle }}


																											</div>-->

														<slot name="firstLine">
<!--															<div v-if="activeChild"
																 class="context-task__parent-title caption grey&#45;&#45;text text&#45;&#45;darken-1"
																 :title="'В этом процессе сейчас выполняется задача '+activeChild.title">
																<v-icon small color="green">
																	mdi-transit-connection-horizontal
																</v-icon>
																<span class="text-overflow">{{ item.title + " (" + activeChild.position + "/" + totalSubtasks + ")" }}</span>
															</div>-->
														</slot>

														<div class="context-task__name">

															<tag-delayed :item="item" class="mr-2"/>

															<!--															<v-icon v-if="item.isProcess" small color="green" class="ml-0 mr-1">mdi-ray-start-arrow</v-icon>-->

															<span class="context-task__name-text">

																<template v-if="timerUsers?.length">
																	<avatar v-for="(user, userIndex) of timerUsers"
																			:key="'user'+userIndex" :user="user"
																			class="mr-2"/>
																</template>

																<tag v-if="isTabDeleted && item.deletedAt" class="mr-3"
																	 grey
																	 mono
																	 :title="'Задача удалена в '+deletedAtHtml"
																	 :small="!compact"
																	 :x-small="compact">{{
																		deletedAtHMHtml
																	}}
																</tag>

																<v-btn v-if="item.isHidden" icon x-small class="mr-3"
																	   title="Отменить скрытие задачи"
																	   @click.stop.prevent="onClickUnhide">
																	<v-icon x-small color="blue" class="ma-0">mdi-eye-off-outline</v-icon>
																</v-btn>

<!--																<v-icon v-if="item.isFolder" small color="grey" class="icon ml-0 mr-3">{{ folderIcon }}</v-icon>-->

																<!--													<span v-if="isTabDeleted" class="__date">{{ item.deletedAt | date }}</span>-->
																<span v-html="titleHtml"></span>

<!--																<span v-if="item.isScaffold && item.userTaskCount"
																	  class="context-task__scaffold-count"
																	  :title="'Задач внутри: '+item.userTaskCount">{{ item.userTaskCount }}</span>-->

																<tag v-if="isNewTask" :class="COLOR_NEW" class="ml-1" dark
																	 :small="!compact" :x-small="compact"
																	 title="Новая задача">new</tag>

																<v-btn v-if="isTaskRepeated(item)" icon x-small class="ml-1"
																	   :title="repeatStatusText(item, 'Задача повторяется')"
																	   @click.stop.prevent="onClickRepeatedOrTemplate">
																	<v-icon x-small :color="COLOR_TASK_TEMPLATE" class="ma-0">mdi-repeat</v-icon>
																</v-btn>
<!--																<tag
																	v-if="isTaskRepeated(item)"
																	:class="COLOR_TASK_TEMPLATE" dark
																	title="Задача повторяется">повторяется
																</tag>-->
																<tag
																	v-else-if="item.bellTill && !isTaskDelayed(item) && item.templateId"
																	:class="COLOR_TASK_TEMPLATE" dark
																	title="Задача появилась из шаблона">из шаблона
																</tag>
																<tag
																	v-else-if="item.bellTill && !isTaskDelayed(item)"
																	class="primary" dark
																	title="Задача вернулась из отложенных">вернулась
																</tag>
																<!--														<tag v-else-if="item.bellTill && !isTaskDelayed(item)"
																															 class="blue" title="Задача вернулась из отложенных">снова
																														</tag>-->
																<!--															<v-icon v-else-if="item.bellTill && !isTaskDelayed(item)"
																																	color="primary" x-small
																																	title="Задача вернулась из отложенных">
																																mdi-timer-sand-empty
																															</v-icon>-->
																<v-icon v-if="item.countParents>1" color="primary"
																		x-small
																		title="Несколько расположений">
																	mdi-circle-multiple-outline
																</v-icon>
																<!--															<v-icon v-if="item.totalStages>1 && !item.isFolder"
																																	color="primary" x-small
																																	title="Несколько шагов">
																																mdi-checkbox-multiple-blank-outline
																															</v-icon>-->
																<v-icon v-if="item.followAt" color="orange" x-small
																		title="Отслеживание">
																	mdi-eye-outline
																</v-icon>

																<task-tags :item="item"/>

																<v-btn v-if="item.withAccessByLink && hasFullAccessToTask(item)" icon x-small
																	   title="Предоставлен доступ по ссылке"
																	   @click="confirmAndMakeTaskAccessibleByLink(item,false)">
																	<v-icon x-small color="green">mdi-lock-open-variant-outline</v-icon>
																</v-btn>

															</span>
														</div>

														<slot name="lastLine">
															<div v-if="activeChild"
																 class="context-task__parent-title caption grey--text text--darken-1"
																 :title="'В этом процессе сейчас выполняется задача '+activeChild.title">
																<v-icon small color="green">
																	mdi-transit-connection-horizontal
																</v-icon>
																<span class="text-overflow">{{ item.title + " (" + activeChild.position + "/" + totalSubtasks + ")" }}</span>
															</div>
															<div v-if="parentPaths" v-for="(path, pathIndex) of parentPaths" :key="'path'+pathIndex"
																 class="context-task__path caption text-overflow grey--text">
																<template v-for="(segment, segmentIndex) of path">
																	<span v-if="segmentIndex" :key="'sep'+segmentIndex" class="__sep">/</span>
																	<router-link v-if="routeOfPathSegment(path, segmentIndex)"
																				 :key="'seg'+segmentIndex"
																				 :to="routeOfPathSegment(path, segmentIndex)" class="__segment grey--text"
																				 draggable="false" @click.native.stop>{{ segment.name }}</router-link>
																	<span v-else :key="'seg'+segmentIndex" class="__segment">{{ segment.name }}</span>
																</template>
															</div>
														</slot>

													</div>
												</div>

												<div v-if="!!image && !withContent" class="context-task__thumb">
													<v-img :src="image.srcThumb" :lazy-src="image.srcLazy"/>
												</div>

												<!--										<v-icon v-else-if="item.bellTill && !isTaskDelayed(item)"
																								class="ml-2 success&#45;&#45;text">
																							mdi-new-box
																						</v-icon>-->
											</div>

										</component>
									</draggable>

									<!--							<div v-if="isReadonly" class="context-task__tools">
																	<v-btn text>Выбрать</v-btn>
																</div>-->
								</div>

								<div v-if="!isReadonly && !isTaskReminder(item)"
									 class="context-task__tools --mt">

									<template v-if="!isTaskComment(item)">
										<btn-urgent v-if="activeChildItem.deadline && activeChildItem.userId" :item="activeChildItem" :disabled="disabled"
													 :class="{'--visible-on-hover': !activeChildItem.urgentInGroupIds?.length}"/>
										<deadline v-if="!compact && !item.isNote && !item.isFolder" :item="activeChildItem"
												  :class="{'--visible-on-hover': !activeChildItem.deadline}"
												  :disabled="disabled" small forced/>
										<assignee v-if="isMD" :item="activeChildItem" :disabled="disabled" small/>
									</template>
									<task-menu-btn :item="item" small class="--visible-on-hover"/>
								</div>

							</div>
						</div>

						<template v-if="!isMD">
							<div class="context-task__swiped-tools --left">
								<v-icon>mdi-check</v-icon>
							</div>
							<div class="context-task__swiped-tools --right">
								<v-icon>mdi-pause</v-icon>
							</div>
						</template>

						<mutation v-if="$store.state.ui.mutations.task.subjectAuth === item.auth"
								  :mutation="$store.state.ui.mutations.task" :subject="item"/>

						<div v-if="draggable" class="draggable__handle"
							 @mousedown.prevent.stop="event=>onHandleMouseDown(event, onMouseDown)">
							<v-icon>mdi-drag-vertical</v-icon>
						</div>
					</div>
				</template>
			</draggable>

			<template v-if="withTree && hasChildren && isOpen && this.isMD">
				<div class="context-task__children">
					<context-tasks v-if="typeof item.children != 'undefined'"
								   :items="item.children"
								   :parent-index="index"
								   :parent="item"
								   :readonly="isReadonly"
								   :force-tree="withTree"
								   :without-context-filter="withoutContextFilter"
								   :with-new-task="withNewTask"
								   :with-new-folder="withNewFolder"
								   :with-track="withTrack"
								   :excluded-items="excludedItems"
								   :open-ids="openIds"
								   :level="level+1"
								   @select="child=>$emit('select',child)"/>
					<v-skeleton-loader v-else type="list-item@2" class="ml-12 mr-8"/>
				</div>
			</template>
		</template>
	</div>
</template>

<script>
import Vue from "vue";
import Deadline from '@/components/elements/deadline';
import Assignee from "@/components/elements/assignee";
import BtnUrgent from "@/components/btns/btn-urgent";
import TaskMenuBtn from "@/components/task/task-menu-btn";
import ContextMenuBtn from "@/components/context/context-menu-btn";
import Mutation from "@/components/elements/mutation";
import {date2Iso, iso2Date, iso2DDMMYYYY, mysql2Date, mysql2DDMMYYYY, mysql2HHMM} from "@/utils/date";
import Config from "@/config";
import vp from "@/mixins/vp";
import base from "@/mixins/base";
import {findPs} from "@/utils/p";
import FileUtils from "@/utils/file";
import striptags from "striptags";
import {end, maxWords, urlify} from "@/utils/string";
import {nick} from "@/utils/user";
import storage from "@/utils/storage";
import {
	TABS,
	tagsFromText,
	clearName,
	tasksOfContext,
	countContextTasks,
	countContextInactiveTasks, contextIdChainFor, hasProcessInChain, sortByPrio, SORT_TYPES, MODES, appendPayloadWithContextIds, parseContextIdChain
} from "@/utils/task";
import {obtainRootContext} from "@/utils/context";
import BtnPrio from "@/components/btns/btn-prio";
import {PRESETS} from "@/utils/pick";
import {posParent} from "@/utils/pos";
import draggable from '@/components/elements/draggable2';
import TagDelayed from "@/components/tags/tag-delayed";
import {parentsOf} from "@/utils/utils";
import TaskTags from "@/components/task/task-tags";
import ContextProgress from "@/components/context/context-progress";
import TaskColor from "@/components/task/task-color";

const SLIDE_THRESHOLD = 5;
const SLIDE_DONE_WIDTH_SHARE = .25; // share of screen width to finish swipe
const SLIDE_ACTION_CONFIRMATION_TIME = 0;

export default {
	name: "context-task",
	mixins: [vp, base],
	components: {
		ContextProgress,
		TaskTags, TagDelayed, Assignee, BtnUrgent, Deadline, TaskMenuBtn, ContextMenuBtn, Mutation, BtnPrio, draggable,
		TaskColor
	},
	props: {
		parent: {},
		item: {},
		/** Полный (нефильтрованный) список задач, среди которых находится item - передается в btn-prio. */
		siblings: {
			type: Array,
			default: null
		},
		index: {},
		total: {},
		/** Предыдущая / следующая строка списка - шаг процесса, выполненный заранее (для зелёной линии трека между ними) */
		trackLinkPrev: {
			type: Boolean,
			default: false,
		},
		trackLinkNext: {
			type: Boolean,
			default: false,
		},
		level: {
			type: Number,
			default: 0,
		},
		withGroupName: {
			type: Boolean,
			default: false
		},
		withTopicName: {
			type: Boolean,
			default: false
		},
		withTree: {
			type: Boolean,
			default: false
		},
		/** см. context-tasks.vue: если задан - открыты только перечисленные id, localStorage не используется */
		openIds: {
			type: Array,
			default: null
		},
		withNewTask: {
			type: Boolean,
			default: false
		},
		withNewFolder: {
			type: Boolean,
			default: false
		},
		withTrack: {
			type: Boolean,
			default: false
		},
		withContent: {
			type: Boolean,
			default: false
		},
		compact: {
			type: Boolean,
			default: false
		},
		plain: {
			type: Boolean,
			default: false
		},
		readonly: {
			type: Boolean,
			default: false
		},
		/**
		 * Skips the page-level context filter when fetching children - see context-tasks.vue.
		 */
		withoutContextFilter: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		draggable: {
			type: Boolean,
			default: false
		},
		/**
		 * Строка "цель процесса": родительская задача процесса, продублированная последней строкой его списка.
		 * Не раскрывается, не выбирается и не принимает перетаскиваемые задачи.
		 */
		goal: {
			type: Boolean,
			default: false
		},
		/*stage: {
			type: Boolean,
			default: false
		},*/
		excludedItems: {
			type: Array,
			default: null
		},
		/**
		 * Set id выбранных задач для O(1)-проверки isSelected вместо selectedTasks.find()
		 * на каждой из строк списка. Опционален - при отсутствии используется selectedTasks.
		 */
		selectedIds: {
			type: Set,
			default: null
		}
	},
	data: () => ({
		touchStartEvent: null,
		willSetDoneAtTouchEndEvent: null,
		willSetDelayAtTouchEndEvent: null,
		willBeUndone: false,
		slidedX: 0,
		timeOfSlideAction: null,
		isOpen: false,
		isFetchingChildren: false,
	}),
	computed: {
		selectedTasksExceptThisItem() {
			return this.selectedTasks?.filter(el => el.id !== this.item.id);
		},
		indexText() {
			return this.index + 1;
		},
		/*acceptsZones() {
			const zones = [];
			if (this.sortable) zones.push("tasks");
			return zones;
		},*/
		rejectIds() {
			const parents = this.parentsOfTask(this.item);
			const parentIds = parents?.map(el => el.id);
			return [...(parentIds || []), this.item.id];
		},
		timerUsers() {
			if (!this.item.timerUserIds) return null;
			return this.item.timerUserIds.map(userId => this.usersById.get(userId)).filter(el => !!el);
		},
		/*isOpen: {
			get() {
				return this.isForcedOpen
					|| !!this.item.children.find(child => child.id === this.page.task.item?.id);
			},
			set(v) {
				this.isForcedOpen = v;
			}
		},*/
		/** Задача создана менее Config.NEW_TASK_HOURS часов назад */
			isNewTask() {
				if (!this.item.createdAt) return false;
				const msDifference = new Date() - iso2Date(this.item.createdAt);
				return !isNaN(msDifference) && msDifference < Config.NEW_TASK_HOURS * 60 * 60 * 1000;
			},
			isReadonly() {
			return this.readonly || this.disabled || !this.hasSomeAccessToTask(this.item);
		},
		isDone() {
			//if (this.item.isTopic) return this.isTopicDone(this.item);
			return this.isTaskDone(this.item);
		},
		isSelected() {
			if (this.goal) return false;
			if (this.selectedIds) return this.selectedIds.has(this.item.id);
			return !!this.selectedTasks?.find(el => el.id === this.item.id);
		},
		isPending() {
			const pendingTaskId = this.$store.state.ui.pending.taskId;
			if (!pendingTaskId) return false;
			return this.item.id === pendingTaskId || this.item.auth === pendingTaskId;
		},
		isLink() {
			//return !(this.disabled || this.readonly || this.item.isFolder);
			//return !(!this.hasFullAccessToTask(this.item) || this.disabled || this.readonly);
			//return !(!this.hasFullAccessToTask(this.item) || this.disabled || this.readonly);
			return !this.isReadonly && !this.isTaskComment(this.item);
		},
		/*withProgress() {
			return !!this.item.isProcess;// && !!this.item.countAssignableChildren;
		},*/
		withNavPath() {
			return false;
			//return (this.withGroupName || (this.withTopicName && this.topicOfItem)) && !this.compact;
		},
		groupOfItem() {
			return this.groupOfTask(this.item);
		},
		topicOfItem() {
			return this.topicOfTask(this.item);
		},
		/**
		 * Полные пути "проект/папка/папка" до задачи - показываются под названием во всех контекстах,
		 * кроме группы и задачи (папки). Если бэкенд путь не прислал - показываем только проекты.
		 */
		parentPaths() {
			const ctx = this.context.item;
			if (!ctx || ctx.isGroup || ctx.isTask || ctx.isFolder) return null;
			// в дереве пользователя путь задан самой структурой
			if (this.context.userTree) return null;
			if (this.item.parentPaths?.length) return this.item.parentPaths;
			if (!this.item.groupIds?.length) return null;
			const paths = this.item.groupIds
				.map(id => this.groups?.find(el => String(el.id) === String(id)))
				.filter(el => !!el)
				.map(group => [{id: group.id, name: group.name, isGroup: true}]);
			return paths.length ? paths : null;
		},
		assigneeOfItem() {
			return this.usersById.get(this.item.userId);
		},
		files() {
			return this.item.files;
		},
		attachedFiles() {
			return this.files?.filter(el => !el.isInline);
		},
		tagsFromText() {
			return tagsFromText(this.item.name);
		},
		tagsText() {
			let text = this.tags?.slice(0, 3).sort().join(", ");
			if (this.tags?.length > 3) text += "...";
			return text;
		},
		/** Панельный режим: эта задача открыта в следующей (правой) панели цепочки */
		isOpenedInNextPanel() {
			const id = this.panelScope?.nextPanelId;
			return !!id && (this.item.id === id || this.item.auth === id);
		},
		componentClass() {
			const c = [];
			///if (this.stage) c.push("--stage");
			c.push("--level-" + this.level);
			if (this.plain) c.push("--plain");
			if (this.isTaskDone(this.item)) c.push("--done");
			if (this.withContent) c.push("--with-content");
			if (this.total && this.index >= this.total - 1) c.push("--last");
			if (this.goal) {
				c.push("--goal");
			} else if (this.parent.isProcess) {
				if (this.parent.id === this.context.item?.id) {
					c.push("--with-root-steps");
				}
			}
			return c.length ? c : null;
		},
		itemClass() {
			const c = [];
			//if (this.isReadonly) c.push("--weak");
			if (this.readonly || !this.hasFullAccessToTask(this.item)) c.push("--readonly");
			if (this.compact) c.push("--compact");
			//if (this.item.isFolder) c.push("--folder");
			//if (this.item.isProcess) c.push("--process");
			//if (this.hasTopic) c.push("--topic");
			if (this.item.countParents > 1) c.push("--multiple-nav-paths");
			if (!this.isReadonly && this.isSelected) c.push("--selected");
			if (this.goal) c.push("--goal");
			if (this.isTaskComment(this.item)) c.push("--comment");
			if (this.isPending) c.push("--pending");
			if (this.item.isScaffold) c.push("--scaffold");

			//const rootContext = obtainRootContext(this.context.item);
			//if (this.tab !== TABS.ACTUAL || this.compact || rootContext?.withoutTabs) c.push("--ignore-inactivity");
			//if (this.tab !== TABS.ACTUAL || this.context.item?.mode !== MODES.TREE) c.push("--ignore-inactivity");
			//if (this.context.item?.mode && this.context.item?.mode !== MODES.TREE) c.push("--ignore-inactivity");

			if ((this.isTaskDone(this.item) || this.willSetDoneAtTouchEndEvent) && !this.willBeUndone) c.push("--done");
			else if (this.isTaskDeferred(this.item)) c.push("--weak");
			else if (this.isTaskDeleted(this.item)) c.push("--deleted");
			else if (this.isTaskDelayed(this.item)) c.push("--weak");
			else if (this.isTaskInactive(this.item)) c.push("--weak");
			/** В процессе все дочерние задачи, кроме активной (текущего шага), - приглушённые */
			else if (!this.goal && this.parent.isProcess && this.parent.firstAssignableChild && (this.parent.firstAssignableChild.childId || this.parent.firstAssignableChild.taskId) !== this.item.id) c.push("--weak");
			//else if (this.item._sealed) c.push("--weak");
			//else if (this.item.isNote) c.push("--weak");
			/*else if (
				this.item.userId !== this.user.id && !this.isTaskOverdue(this.item)
				&& this.context.item?.preset === PRESETS.MY
				&& !this.isReadonly
			) c.push("--weak");*/
			//else if (this.item.prio) c.push("--bg-prio");
			//else if (this.item.color) c.push("--bg-" + this.item.color.substr(2));


			if (!this.isReadonly
				&& this.isRouteSomeTask
				&& (this.item.id === this.page.task.item?.id
					|| this.item.id === this.page.task.item?.auth)
				&& !this.$store.state.ui.pending.taskId
			) c.push("--current");
			// панельный режим: задача, открытая в следующей панели цепочки, - текущая в списке своей панели
			else if (this.isOpenedInNextPanel) c.push("--current");

			/*c.push("--border-accent");
			//if (this.item.isActive) {
			if (this.item.color) {
				c.push(this.item.color);
			}*/
			//}


			/*if (this.isMD) {
				if (this.item.color) c.push("--bg-" + this.item.color.substr(2));
			}*/
			/*if (this.item.deadline) {
				const {color} = deadlineTextAndCss(this.item);
				c.push("--bell");
			}*/
			//if (this.item.bellTill) c.push("--bell");
			if (this.willSetDelayAtTouchEndEvent || this.willSetDoneAtTouchEndEvent) c.push("--slided");
			/*
			else if (this.item.delayedTill || this.item.isDelayed) c.push("--backlog");
			else if (this.index >= Config.TODOS_MAX_MAIN) c.push("--backlog");*/
			return c.length ? c : null;
		},
		itemStyle() {
			const s = [];
			if (this.isMD) {
				let left = this.level * 26;
				//if (hasProcessInChain(this.parent, this.context.item)) left += 32;
				s.push({paddingLeft: left + "px"});
			}
			return s.length ? s : null;
		},
		/**
		 * Элемент трека процесса для btn-prio ({kind, state, last}) или null, если трек не нужен.
		 */
		prioTrack() {
			if (!this.withTrack || !this.parent.isProcess || !this.isMD) return null;
			const last = !!this.total && this.index >= this.total - 1;
			const done = this.isTaskDone(this.item);
			if (this.goal) {
				/** Цель достигнута: сама задача выполнена или не осталось шагов к выполнению */
				return {kind: "goal", state: done || !this.parent.firstAssignableChild ? "passed" : "upcoming", last};
			}
			const first = this.parent.firstAssignableChild;
			let state = "upcoming";
			if (first?.index > this.item.index) state = "passed";
			else if ((first?.childId || first?.taskId) === this.item.id) state = "current";
			/** Невыполненных шагов не осталось - все выполненные шаги пройдены */
			else if (!first && done) state = "passed";
			return {kind: "step", state, last};
		},
		/**
		 * Ids of the ancestor chain encoded in the current context-task route (excludes the deep-linked
		 * task itself). Used to re-expand the tree down to that task on a fresh page load, since the
		 * displayed root context may have been collapsed back to the real root (see contextIdChainFor()
		 * and ContextModule.item() on the backend).
		 */
		routeContextChainIds() {
			if (this.$route.name !== 'context-task') return null;
			return parseContextIdChain(this.$route.params.contextId)?.ids || null;
		},
		isForcedOpenByRouteChain() {
			if (!this.routeContextChainIds?.length) return false;
			const key = this.item.auth || this.item.id;
			return this.routeContextChainIds.includes(key);
		},
		hasTopic() {
			const rootContext = obtainRootContext();
			//console.log("rootContext", rootContext);
			//console.log("rootContext is group", rootContext?.isGroup);
			if (this.item.topicData?.length && rootContext?.isGroup) {
				//console.log("rootContext", rootContext.contextId);
				//return this.groups?.some(el=>this.item.topicsInGroups.includes(el.contextId));
				return this.item.topicData.find(el => el.groupContextId === rootContext.contextId);
			}
			return false;
		},
		slideClass() {
			const c = [];
			return c.length ? c : null;
		},
		slideStyle() {
			const s = [];
			if (this.slidedX) s.push({transform: "translateX(" + this.slidedX + "px)"});
			return s.length ? s : null;
		},
		linkComponent() {
			return this.isLink ? 'router-link' : 'div';
		},
		repeatTitle() {
			let repeatDays = this.item.repeatDays;
			//console.log("type of repeatDays", this.item.auth, this.item.repeatDays, typeof repeatDays === "string");
			if (typeof repeatDays === "string") {
				try {
					repeatDays = JSON.parse(repeatDays);
				} catch (e) {
				}
			}
			//else if (!repeatDays) repeatDays = [false, false, false, false, false, false, false];

			let repeatText = "";
			if (this.item.repeat === "hourly") {
				repeatText = "ежечасно";
			} else if (this.item.repeat === "daily") {
				repeatText = "ежедневно";
			} else if (repeatDays) {
				if (this.item.repeat === "weekly") {
					repeatText = "в дни недели: " + Config.DAY_LABELS.filter((el, index) => repeatDays.includes(index)).join(", ");
				} else if (this.item.repeat === "monthly") {
					repeatText = "ежемесячно по числам: " + repeatDays.map(el => el + 1).join(", ");
				} else if (this.item.repeat === "yearly") {
					repeatText = "ежегодно" + end(repeatDays.length, "", " в такие дни", " в такие дни") + ": " + repeatDays.map(el => iso2DDMMYYYY(el).substring(0, 5)).join(", ");
				}
			}
			return repeatText ? "Задача повторяется " + repeatText : "Это шаблон";
		},
		repeatText() {
			let repeatDays = this.item.repeatDays;
			//console.log("type of repeatDays", this.item.auth, this.item.repeatDays, typeof repeatDays === "string");
			if (typeof repeatDays === "string") {
				try {
					repeatDays = JSON.parse(repeatDays);
				} catch (e) {
				}
			}
			//else if (!repeatDays) repeatDays = [false, false, false, false, false, false, false];

			//console.log("repeat", this.item.repeat);
			let repeatText = "без повторений";
			if (this.item.repeat === "hourly") {
				repeatText = "ежечасно";
			} else if (this.item.repeat === "daily") {
				repeatText = "ежедневно";
			} else if (repeatDays) {
				if (this.item.repeat === "weekly") {
					repeatText = Config.DAY_LABELS.filter((el, index) => repeatDays.includes(index)).join(", ");
				} else if (this.item.repeat === "monthly") {
					repeatText = repeatDays.map(el => el + 1).join(", ");
				} else if (this.item.repeat === "yearly") {
					repeatText = maxWords(repeatDays.map(el => iso2DDMMYYYY(el).substring(0, 5)).join(", "), 3);
				}
			}
			return repeatText;
		},
		/** Текущий (активный) шаг процесса, если задача - процесс */
		activeChild() {
			if (this.goal || !this.item.isProcess || !this.item.firstAssignableChild?.taskId) return null;
			return this.item.firstAssignableChild;
		},
		/**
		 * Задача, над которой выполняются исполнитель/дедлайн: для процесса - его активный шаг,
		 * иначе сама задача. Если дети процесса ещё не загружены, собираем лёгкий объект из снимка шага
		 * (доступ шага считаем унаследованным от процесса).
		 */
		activeChildItem() {
			if (!this.activeChild) return this.item;
			const loaded = this.item.children?.find(el => el.id === this.activeChild.taskId);
			if (loaded) return loaded;
			return {
				id: this.activeChild.taskId,
				title: this.activeChild.title,
				userId: this.activeChild.userId,
				deadline: this.activeChild.deadline,
				contextId: this.item.id,
				isActive: true,
				withFullAccess: this.item.withFullAccess,
			};
		},
		titleHtml() {
			let name = this.activeChild ? this.activeChild.title : this.item.title;
			//if ( this.item.relatedTitle ) name += ": "+this.item.relatedTitle;
			if (!name) {
				return this.item.isFolder ? "<i>Новая папка</i>" : "<i>Новая задача</i>";
			}
			//return this.hasSomeAccessToTask(this.item) + ": " + name;
			//return (this.item.accessUserData ? "(" + this.item.accessUserData?.map(el => el.userId + ":" + el.withFullAccess) + ") " : "") + name;
			//return (this.item.accessGroupData ? "(" + this.item.accessGroupData?.map(el => el.groupId + ":" + el.withFullAccess) + ") " : "") + name;
			//return this.item.index + ". " + this.item.id + " " +name;
			//return this.hasFullAccessToTask(this.item) + ": " +name;
			//return this.isReadonly + ": " +name;
			//return this.item.groupIds + ". " + name;
			//return this.item.contentId + " " + name;
			//return this.item.contextId + " / " + this.item.id + " " + name;
			//return this.parent?.id + ". " + name;
			//return this.parent?.id +":" + this.item.id + name;
			//return this.item.parent?.id + ". " + name;
			//return this.isTaskInactive(this.item) + ". " + name;
			//return this.item.isActive + ". " + name;
			//return this.item.id + ". " + name;
			//return this.isComplexTask(this.item) + ". " + name;
			//return this.item.tagIds?.join("|") + ". " + name;
			//return this.item.hasTopic + " / " + this.item.auth + ". " + name;
			//return this.level + ". " + name;
			//return this.item.auth + ". " + name;
			//return this.item.updatedAt + ". " + name;
			//return this.item.delayedTill + ". " + name;
			//return this.item?.length + ". " + name;
			//return this.item.userActivityAt + ". " + name;
			//return this.item.countChildren + ". " + name;
			//return this.item.countActiveChildren + ". " + name;
			//return this.item.countAssignableChildren + ". " + name;
			//return this.item.children?.length + ". " + name;
			//return this.item.taskLogCreatedAt + ". " + name;
			//return this.item.prio + ". " + name;
			//return this.parentsOfTask(this.item)?.length+ ". " + name;
			return name;
		},
		contentHtml() {
			return this.item.content;
			//const html = striptags(this.item.content, ["b", "i", "em", "img", "p"]);
			//return urlify(html);
		},
		deletedAtHtml() {
			return mysql2DDMMYYYY(this.item.deletedAt) + " " + mysql2HHMM(this.item.deletedAt);
		},
		deletedAtHMHtml() {
			return mysql2HHMM(this.item.deletedAt);
		},
		image() {
			if (!this.item?.files) return null;

			const images = this.item?.files.filter(file => FileUtils.isImage(file));
			if (!images?.length) return null;
			images.reverse();	// todo think how to force asc task.files sorting on BE
			return images[0];

			/*const tags = this.item.name.match(/<img [^>]*data-src-thumb="[^"]*"[^>]*>/gm);
			const thumbs = tags?.map(x => x.replace(/.*data-src-thumb="([^"]*)".*!/, '$1'));
			const lazys = tags?.map(x => x.replace(/.*data-src-lazy="([^"]*)".*!/, '$1'));
			//console.log(this.item.id + "TAGS", tags);
			if (thumbs?.length) return {
				srcThumb: thumbs[0],
				srcLazy: lazys[0],
			};
			return null;*/
		},
		progress() {
			return countContextInactiveTasks(this.item) * 100 / this.totalChildren;
		},
		openIcon() {
			return this.isOpen ? "mdi-chevron-down" : "mdi-chevron-right";
		},
		folderIcon() {
			if (this.isOpen && this.isMD) return "mdi-folder-open-outline";
			if (this.item.isNote) return "mdi-folder-information-outline";
			return "mdi-folder-outline";
		},
		/** Дерево пользовательского контекста: дети пришли целиком, чужие подзадачи не подгружаются. */
		isUserTreeRow() {
			return !!this.context.userTree && Array.isArray(this.item.children);
		},
		/** Ключ storage со списком id: в дереве пользователя хранятся закрытые узлы (по умолчанию всё открыто), иначе открытые. */
		openStorageKey() {
			return this.isUserTreeRow ? Config.STORAGE_USER_TREE_CLOSED : Config.STORAGE_OPEN_CONTEXTS;
		},
		hasChildren() {
			// цель процесса - дубль родителя, раскрывать её нельзя (рекурсия: тот же item и ключ состояния open)
			if (this.goal) return false;
			// note: intentionally not gated by this.readonly - browsing/expanding into children
			// (e.g. in dialog-task-move.vue) must stay possible even in interactivity-limited mode.
			// disabled/no-access still hide it, as those mean the task truly should not be opened.
			if (this.isUserTreeRow) return !this.disabled && this.hasSomeAccessToTask(this.item) && this.item.children.length > 0;
			return !this.disabled
				&& this.hasSomeAccessToTask(this.item)
				&& (this.item.isFolder
					//|| this.item?.countChildren
					|| this.item?.countActiveChildren
					|| this.item.children?.length > 0);
		},
		totalChildren() {
			return this.item.children?.length || 0;
		},
		totalSubtasks() {
			return (this.item.countAssignableChildren || 0) + this.countDoneSubtasks;
		},
		countDoneSubtasks() {
			return this.item.countDoneChildren || 0;
		},
	},
	watch: {
		'item.id'() {
			this.detectInlineImages();
		},
		'context.item': {
			//immediate: true,
			handler() {
				this.fetchChildrenIfOpen();
			}
		},
		'page.task.item': {
			immediate: true,
			handler() {
				// open item if route task pos includes this pos
				if (this.item && this.isRouteSomeTask && !this.isReadonly) {
					const task = this.page.task.item;
					if (task?.id === this.item.id) {
						// отключено: клик по задаче не должен автоматически раскрывать список дочерних задач
						// (механизм оставлен закомментированным, может понадобиться вернуть)
						// this.isOpen = true;
						// this.fetchChildrenIfOpen();
						/*if (task.pos.substring(0, this.item.pos.length) === this.item.pos) {
							this.isOpen = true;
							this.fetchChildrenIfOpen();
						}*/
					}
				}
			}
		}
	},
	methods: {
		onHandleMouseDown(event, onMouseDown) {
			// clear all selections if this item is not in selected tasks
			const isInSelected = this.selectedTasks?.find(el => el.id === this.item.id);
			if (!isInSelected) {
				this.commit("contextClearSelectedTasks");
			}

			// todo select this item?

			// proxy event to draggable
			if (onMouseDown) onMouseDown(event);
		},
		/**
		 * Called when drag of the task initiated.
		 */
		onDragStart(payload) {
			this.$emit('drag-start', payload);
		},
		/**
		 * Called when drag of the task is finished (with any result).
		 * Destination may be undefined.
		 * @param source
		 * @param destination
		 */
		onDragEnd(source, destination) {
			//console.log("onDragEnd", source, destination);

			// temporally disable selected for better d-n-d animation
			// TODO rewrite! as it prevents --dragging from clearing in <draggable>
			const temp = this.selectedTasks;
			this.commit("contextClearSelectedTasks");
			setTimeout(() => {
				this.commit("contextSetSelectedTasks", temp);
			}, 250);	// DROPPING_TIME FROM draggable2.vue + some delta - BUT BEWARE TOO LARGE VALUES!?

			this.$emit('drag-end');
		},
		/**
		 * Called when smth is dropped over this task.
		 * @param source
		 * @param destination = this task element
		 */
		async onDropOverTask(source, destination) {
			return new Promise(async (resolve, reject) => {
				console.log("onDropOverTask", source, destination);

				if (source.zone === "tasks") {
					// a task dropped over this task

					if (!source.payload?.length) return reject();

					/*console.log("SOURCE contextIds", source.payload.map(el => el.contextId));
					console.log("DEST contextId", this.item.id);*/

					const contextId = this.item.id;
					const fromContextIds = source.payload.map(el => el.contextId);

					// todo check make mass move, make folders support
					await this.do('task/move', {
						// source task ids
						taskIds: source.payload.map(el => el.id),
						// source contexts (in same order)
						fromContextIds,
						// target context
						contextId,
						// desired index
						//index: 0,
						// current filter to refetch context tasks
						//filter: this.context.item?.filter
					});

					console.log("MOVED!", source.payload);
					resolve();
				} else reject();
			});
		},
		onToggleDone() {
			this.toggleTaskDone(this.item);
		},
		onClickUnhide() {
			this.do("task/update", {
				taskId: this.item.id,
				params: {isHidden: false},
			});
		},
		onToggleChildren() {
			this.isOpen = !this.isOpen;
			if (!this.openIds) this.commit("uiStoreIdInList", {
				key: this.openStorageKey,
				id: this.item.id,
				value: this.isUserTreeRow ? !this.isOpen : this.isOpen
			});
			this.fetchChildrenIfOpen();
		},
		onClickRepeatedOrTemplate() {
			this.$store.dispatch("task/dialogTemplate", {
				item: this.item,
			});
		},
		onClickDeferred() {
			this.showDialogTaskDefer(this.item);
			/*console.log("!!!!!!");
			this.$store.dispatch("task/dialogDelay", {
				item: this.item,
			});*/
		},
		onTouchStart(event) {
			console.log("onTouchStart", event);

			//if (this.item.isFolder) return;
			if (this.isReadonly) return;
			if (this.isMD) return;
			if (this.isAnon) return;

			this.touchStartEvent = event;
			this.willSetDoneAtTouchEndEvent = null;
			this.willSetDelayAtTouchEndEvent = null;
		},
		onTouchMove(event) {
			if (this.willSetDoneAtTouchEndEvent) return;
			if (this.isReadonly) return;
			if (this.isMD) return;
			if (this.isAnon) return;

			const startX = this.touchStartEvent.changedTouches[0].screenX;
			const startY = this.touchStartEvent.changedTouches[0].screenY;
			const x = event.changedTouches[0].screenX;
			const y = event.changedTouches[0].screenY;
			const slideDone = window.innerWidth * SLIDE_DONE_WIDTH_SHARE;
			if (Math.abs(x - startX) > Math.abs(y - startY)) {
				if (x > startX + SLIDE_THRESHOLD) {
					if (x <= startX + slideDone) {
						this.slidedX = x - startX;
					}
					if (x >= startX + slideDone) {
						this.slidedX = slideDone;
						this.timeOfSlideAction = new Date();
						this.willSetDoneAtTouchEndEvent = event;
						this.willBeUndone = this.isTaskDone(this.item);
					}
				} else if (x < startX - SLIDE_THRESHOLD) {
					if (x >= startX - slideDone) {
						this.slidedX = x - startX;
					}
					if (x <= startX - slideDone) {
						this.slidedX = -slideDone;
						this.timeOfSlideAction = new Date();
						this.willSetDelayAtTouchEndEvent = event;
					}
				}
			}
		},
		onTouchEnd(event) {
			console.log("onTouchEnd", event);
			if (this.isReadonly) return;
			if (this.isMD) return;
			if (this.isAnon) return;

			if (this.willSetDoneAtTouchEndEvent) {
				const now = new Date();
				if (this.timeOfSlideAction) {
					if (this.timeOfSlideAction.valueOf() + SLIDE_ACTION_CONFIRMATION_TIME < now.valueOf()) {
						this.toggleTaskDone(this.item);
					}
				}
				this.willSetDoneAtTouchEndEvent = null;

			} else if (this.willSetDelayAtTouchEndEvent) {
				const now = new Date();
				if (this.timeOfSlideAction) {
					if (this.timeOfSlideAction.valueOf() + SLIDE_ACTION_CONFIRMATION_TIME < now.valueOf()) {
						this.showDialogTaskDelay(this.item);
					}
				}
				this.willSetDelayAtTouchEndEvent = null;
			}

			this.touchStartEvent = null;
			this.slidedX = 0;
			this.timeOfSlideAction = null;
		},
		onMouseDownOnItem(event) {
			//console.log("onMouseDownOnItem", event, this.item.title);
			if (this.item._sealed || this.goal) return;
			// в обычном режиме папки раскрываются шевроном и не "выбираются" напрямую;
			// в readonly-режиме (выбор назначения, dialog-task-move.vue) клик по папке выбирает её,
			// а раскрытие по-прежнему выполняется только шевроном
			if (this.item.isFolder && !this.isReadonly) return;

			let eventName = "select";
			let withPrevent = false;

			if (!this.isReadonly) {
				if (event?.ctrlKey || event?.metaKey) {
					eventName = "select-ctrl";
					withPrevent = true;
				} else if (event?.shiftKey) {
					eventName = "select-shift";
					withPrevent = true;
				} else if (this.isSelected) {
					eventName = null;
					//withPrevent = true;
				}
				if (withPrevent) {
					event.preventDefault();
					event.stopPropagation();
				}
			}
			if (eventName) {
				this.$emit(eventName, this.item, event);
			}
		},
		onClickComponent(event) {
			if (this.withContent) return;
			event.stopPropagation();
			event.preventDefault();
		},
		onClickItem(event) {
			if (this.isReadonly) return;

			//console.log("onClickItem", this.item.name);
			/*if (this.item.isFolder) {
				//this.route(true);
				//this.onToggleChildren();
				return;
			}*/

			let withPrevent = false;

			if (event?.ctrlKey || event?.metaKey) {
				withPrevent = true;
			} else if (event?.shiftKey) {
				withPrevent = true;
			}
			if (withPrevent) {
				event.preventDefault();
				event.stopPropagation();
			}
		},
		onClickImage(file, index) {
			this.previewFiles(this.files, index);
		},
		onClickInlineImage(event) {
			const index = this.files?.findIndex(el => el.srcThumb === event.target.getAttribute("data-src-thumb"));
			/*console.log("this.item.files", this.files);
			console.log("this.item.files", this.item.files);
			console.log("INDEX", index);*/
			this.previewFiles(this.files, index);
		},
		previewFiles(files, index) {
			//console.log("FILES", files, index);
			this.commit("uiDialogFilesViewer", {
				files,
				index,
			});
		},
		route(forceFolder = false) {
			// панельный режим: любой элемент (даже лист) - новая панель справа, т.е. чистый роут context с добавленным id
			if (this.isPannelView) return this.routeOfContextAppend(this.item, this.parent);
			// цель процесса открывается как задача в контексте самой себя
			let goalContextId;
			if (this.goal) {
				// цепочка контекстов до процесса: если процесс - контекст страницы, это его цепочка из контекста страницы,
				// иначе - цепочка его родителей
				goalContextId = this.context.item?.id === this.item.id
					? [...(this.context.parents || []).map(el => el.id), this.item.id].join(Config.CONTEXT_ID_CHAIN_SEP)
					: this.contextIdChainFor(this.item, undefined, this.item.parent);
			}
			if (this.goal) {
				return {
					name: "context-task",
					params: {
						contextId: goalContextId,
						taskId: this.item.id,
						// контекст перезагружаем, только если он уже не этот процесс
						skipContext: this.context.item?.id === this.item.id && !this.$store.state.ui.isTaskFullscreen,
					},
					query: {...this.$router.currentRoute.query},
				};
			}
			// процесс с активным шагом открываем на этом шаге внутри контекста процесса
			if (this.activeChild && this.context.item) {
				return {
					name: "context-task",
					params: {
						contextId: contextIdChainFor(this.item, undefined, this.parent),
						taskId: this.activeChild.taskId,
					},
					query: {...this.$router.currentRoute.query},
				};
			}
			// вне режима дерева всегда открываем как задачу в контексте (context-task)
			return this.routeOfTask(this.item, this.parent, forceFolder, !this.withTree);
		},
		/** Маршрут на контекст группы (проекта) */
		routeOfGroup(group) {
			return this.routeOfContext({isGroup: true, id: group.id, contextId: group.contextId});
		},
		/**
		 * Маршрут на сегмент пути "проект/папка/папка": проект - контекст группы, папка - контекст
		 * с цепочкой id от проекта до этой папки. null, если проект не найден среди загруженных групп.
		 */
		routeOfPathSegment(path, index) {
			const root = path[0];
			const group = this.groups?.find(el => String(el.id) === String(root.id));
			if (!group) return null;
			if (!index) return this.routeOfGroup(group);
			const chain = [group.contextId || group.id, ...path.slice(1, index + 1).map(el => el.id)];
			return {
				name: "context",
				params: {contextId: chain.join(Config.CONTEXT_ID_CHAIN_SEP)},
				query: {...this.$router.currentRoute.query},
			};
		},
		classOfTag(tag) {
			const c = [];
			if (tag.color) c.push(tag.color);
			else c.push("grey");
			return c.length ? c : null;
			/*if (!tag.color) return null;
			const s = {};
			const color = this.colorByCss(tag.color);
			s.backgroundColor = color.color;
			s.color = color.fg;
			return s;*/
		},
		async fetchChildrenIfOpen() {
			if (this.isFetchingChildren) return;
			if (!this.withTree) return;
			// иначе цель перезапишет сохранённое состояние раскрытия настоящей строки этой же задачи
			if (this.goal) return;
			//console.log("fetchChildrenIfOpen: " + this.item.title + ": "+this.item.children?.length);

			if (!this.openIds) this.commit("uiStoreIdInList", {
				key: this.openStorageKey,
				id: this.item.id,
				value: this.isUserTreeRow ? !this.isOpen : this.isOpen
			});

			if (this.isOpen
				&& typeof this.item.children == "undefined"
				&& (this.item.isFolder || this.item.countChildren)) {

				this.isFetchingChildren = true;

				const contextIdChain = this.contextIdChainFor(this.item, undefined, this.parent);
				//console.log("fetchChildrenIfOpen fetching...: (" + this.parent?.id+") / "+this.item.id);
				console.log("fetchChildrenIfOpen fetching...: " + contextIdChain);

				const payload = {
					contextId: contextIdChain,
					// we always want this node's own children, folder or not - never collapsed to root
					exactContext: true,
					// the backend only applies user.contextTasksFilter when filterFromContextId is set
					filterFromContextId: this.withoutContextFilter ? undefined : this.context.item?.id,
				};
				appendPayloadWithContextIds(this.$store.state, payload);
				const res = await this.fetch("context/item", payload)
					.catch(err => {
						console.warn("error", err);
					}).finally(() => {
						this.isFetchingChildren = false;
					});

				//console.log("FETCHED!");
				this.commit("contextAppendChildTasks", {
					context: this.item,
					items: res?.result?.tasks?.items
				});
			}
		},
		iconOfFile(file) {
			//console.log("File", file.type);
			if (FileUtils.isPDF(file)) return "mdi-file-pdf-box";
			else if (FileUtils.isJPG(file)) return "mdi-file-jpg-box";
			else if (FileUtils.isPNG(file)) return "mdi-file-png-box";
			else if (FileUtils.isGIF(file)) return "mdi-file-gif-box";
			else if (FileUtils.isXLS(file)) return "mdi-google-spreadsheet";
			else if (FileUtils.isArchive(file)) return "mdi-zip-box";
			return "mdi-text-box";
		},
		isImage(file) {
			return FileUtils.isImage(file);
		},
		isPDF(file) {
			return FileUtils.isPDF(file);
		},
		detectInlineImages() {
			// need small pause to apply DOM
			setTimeout(() => {
				//console.log("ID CHANGED: " + this.item.content);
				this.inlineImgs = this.$refs.content?.querySelectorAll("img");
				//console.log("inlineImgs", this.inlineImgs);
				if (this.inlineImgs?.length) {
					this.inlineImgs = [...this.inlineImgs];
					this.inlineImgs.forEach(el => {
						el.addEventListener("click", this.onClickInlineImage);
					});
				}
			}, 50);
		},
	},
	mounted() {
		//console.log("CONTEXT TASK mounted: "+this.item.title);
		if (this.hasChildren) {
			if (this.openIds) {
				this.isOpen = this.openIds.includes(this.item.auth || this.item.id);
			} else {
				let v = storage.get(this.openStorageKey);
				this.isOpen = this.isUserTreeRow ? !v?.includes(this.item.id) : (!!v?.includes(this.item.id) || this.isForcedOpenByRouteChain);
			}
			this.fetchChildrenIfOpen();
		}
		this.detectInlineImages();
	},
	beforeDestroy() {
		this.inlineImgs?.forEach(el => {
			el.removeEventListener("click", this.onClickInlineImage);
		});
	}
}
</script>

<style lang="scss">
@keyframes context-task-pending-shimmer {
	0% {
		background-position: 200% 0;
	}
	100% {
		background-position: -200% 0;
	}
}

.context-task {
	position: relative;
	z-index: 1;

	/*&.--with-root-steps {
		//.context-task__item {
		padding-left: 28px;
	}*/

	&.--plain {
		.context-task__slide {
			padding: 0 .5rem 0 .75rem;
		}

		.context-task__btn-opener {
			display: none !important;
		}
	}

	&.--with-content {
		.context-task__item {
			padding: 0 .5rem 0 .75rem;
		}

		.context-task__line {
			cursor: text;
		}
	}

	&__path {
		.__sep {
			margin: 0 .25rem;
		}

		a.__segment {
			//color: map-get($grey, "darken-1") !important;

			&:hover {
				color: $default-text-color !important;;
			}
		}
	}

	&__item {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		//min-height: 32px;
		//@include transition();

		/*&.--pending {
			position: relative;
			overflow: hidden;

			.context-task__name {

				&::after {
					content: "";
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					z-index: 2;
					pointer-events: none;
					background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, .55) 50%, transparent 100%);
					background-size: 200% 100%;
					animation: context-task-pending-shimmer .5s ease-in-out forwards;
				}
			}
		}*/

		@include up($md) {
			//border: 1px solid transparent; // map-get($grey, "lighten-3");//$color-gray;
			//border-radius: 5px;

			/*&:hover:not(.--folder):not(.--readonly):not(.--deleted) {
				.icon.--check {
					opacity: 1;
				}

				.context-task__index {
					opacity: 0 !important;
				}
			}*/
			/*&:hover:not(.--current) {
				.btn-prio {
					opacity: 1;
				}
			}*/
			&:hover:not(.--current):not(.--comment) {
				z-index: 1;
				background: map-get($grey, "lighten-5");
			}
			&:hover {
				//box-shadow: 0 0 15px map-get($grey, "lighten-3");

				.context-task__name-text, .context-task__content, .assignee, .deadline, .context-progress {
					opacity: 1 !important;
					text-decoration: none !important;
				}

				/*.context-task__name {
					color: $black !important;
				}*/

				/*&:not(.--folder):not(.--readonly):not(.--deleted) {
					.context-task__index {
						opacity: 0;
					}
				}*/

				.btn-prio {
					opacity: 1 !important;
				}

				.--visible-on-hover {
					opacity: 1;
				}
			}
		}

		&.--compact {
			height: 2.8em;

			.context-task__icon {
				width: 28px;
				height: 28px;
				flex-shrink: 0;
				margin: 0 0.25rem 0 0;
			}

			.context-task__line {
				gap: 0.5rem;
				padding-right: 0.25rem;
				padding-left: 0.25rem;
			}

			.context-task__link {
				max-width: calc(100% - 2.25em);
				padding: 0;
				//max-width: 80%;
				.v-chip {
					padding: 0 8px;
				}
			}

			.context-task__thumb {
				width: 48px;
				height: 30px;
				margin-left: .5rem;
			}
		}

		&:not(.--ignore-inactivity).--done,
			//&:not(.--current):not(.--ignore-inactivity).--weak,
		&:not(.--ignore-inactivity).--weak,
		&:not(.--ignore-inactivity).--deleted {

			/*.context-task__name {
				text-decoration: line-through;
				text-decoration-color: $default-text-color; // важно, так как vuetify выставляет прозрачность на text-decoration
			}*/
			.context-task__name-text, .context-task__content, .assignee, .deadline, .context-progress {
				opacity: $opacity-done;
			}

			/*.context-task__index {
				opacity: $opacity-done;
			}*/

			.context-task__thumb {
				opacity: $opacity-done;

				.v-image__image {
					filter: saturate(0);
				}
			}

			/*.btn-prio {
				opacity: $opacity-done;
			}*/

			/*.context-task__delayed {
				opacity: $opacity-done;
			}*/
		}

		/** Папка пользовательского дерева, которая не назначена пользователю: показана как контекст для его задач. */
		&:not(.--ignore-inactivity).--scaffold {
			.assignee {
				opacity: $opacity-done;
			}
		}

		&:not(.--ignore-inactivity).--process {
			.assignee {
				opacity: $opacity-done;
			}
		}

		&:not(.--ignore-inactivity) {
			&.--done, &.--deleted {
				.context-task__name-text, .context-task__content {
					text-decoration: line-through;
					text-decoration-color: $default-text-color; // важно, так как vuetify выставляет прозрачность на text-decoration
				}

				.icon.--check {
					opacity: $default-icon-opacity;
				}

				.task-tags {
					opacity: $opacity-done;
				}
			}
		}

		&:not(.--comment) {
			.context-task__content {
				p {
					&:first-child {
						font-weight: bold;
						margin: 0;
					}

					//margin: .5rem 0 0 0;
				}
			}
		}

		&.--comment {
			/*&:hover {
				background: white;
			}*/

			/*.context-task__content {
				padding: 1.5rem;
			}*/

			padding-left: .75rem; // for color btn
		}

		/*&.--done {
			.context-task__index {
				opacity: 0 !important;
			}
		}*/

		/*&.--deleted {
			.context-task__name {
				text-decoration: line-through;
				text-decoration-color: $default-text-color; // важно, так как vuetify выставляет прозрачность на text-decoration
			}

			.icon.--check {
				opacity: 0;
			}

			.__tag {
				opacity: $opacity-done;
			}
		}*/

		&.--folder {
			.context-task__name {
				font-weight: normal;
				//text-transform: uppercase;
				//letter-spacing: 0.1rem;
			}
		}

		&.--topic {
			.context-task__name {
				color: map-get($blue, "darken-3") !important;
			}
		}

		/*&.--multiple-nav-paths {
			.context-task__name {
				//color: map-get($blue, "darken-3") !important;
				font-style: italic;
			}
		}*/

		/*&.--prio {

		}*/

		/*&.--current {
			//@extend .bg--selected;
			.context-task__name {
				//font-weight: bold;
				color: black;
			}

			!*.context-task__line {
				background: white;
				@include up($md) {
					background: unset;
				}
			}*!

			@include up($md) {
				z-index: 2;
				background: white;
				//background: map-get($blue, "lighten-5");// !important;
				box-shadow: 0 0 7px map-get($grey, "lighten-3");
			}
		}*/

		/** Выбранная (--selected) и открытая (--current) строки выглядят одинаково; условия у классов разные */
		&.--selected,
		&.--current {
			//&:not(.--done):not(.--deleted):not(.--weak)
			.context-task__name {
				//font-weight: bold;
				color: black;
			}

			background: white !important;
		}

		/** Строка цели не выбирается (--selected), поэтому открытая как задача (--current) и наведённая подсвечиваются белым, как выбранные */
		&.--goal.--current,
		&.--goal:hover {
			background: white !important;
		}

		&.--slided {
			.context-task__swiped-tools {
				.v-icon {
					opacity: 1;
				}
			}
		}
	}

	&__slide {
		position: relative;
		z-index: 1;
		width: 100%;
		height: 100%;
		padding: 0 6px 0 .8rem;
		background: white;
		@include up($md) {
			background: unset;
			padding: 0 .5rem 0 2rem;
		}

		&-content {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
		}
	}

	&__btn-opener, &__index, &__btn-prio {
		flex-grow: 0;
		flex-shrink: 0;
	}

	&__btn-opener {
		width: 28px;
	}

	&__first-assignable {
		width: 0;
	}

	&__index, &__btn-prio {
		width: 2rem;
	}

	/*&__btn-folder {
		//background: blue;
		margin-top: 7px;
		margin-right: 0.25rem;
		padding-bottom: 4px;
		text-align: center;
	}*/

	&__btn-prio {
		///padding-top: 1px;
		margin-right: 0.4rem;
	}

	/*&__btn-checker {
		position: relative;
		height: 30px;
		flex-shrink: 0;
		//margin: 0 0.25rem 0 0.75rem;
		//display: none;
		display: flex;
		justify-content: center;
		align-items: center;

		.icon.--check {
			opacity: 0;
		}
	}*/

	&__btn-prio.--track {
		/** Колонка btn-prio с треком процесса тянется на всю высоту строки - линия трека проходит через многострочные шаги */
		align-self: stretch;
		display: flex;
	}

	&__index {
		margin-top: 5px;
		position: relative;
		height: 28px; // same as btn in the line
		line-height: 28px;
		flex-shrink: 0;
		//margin: 0 0.25rem 0 0.75rem;
		//display: none;
		display: flex;
		justify-content: center;
		align-items: center;
		/*position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: none;
		@include transition();

		@include up($md) {
			display: block;
		}*/
	}

	&__line {
		position: relative;
		//width: calc(100% - 2em);
		//width: calc(100% - 62px);
		flex: 1;
		height: 100%;
		flex-shrink: 0;
		display: flex;
		align-items: flex-start;
		//justify-content: space-between;
		//padding-left: .5rem; //$general-padding;
		padding-right: .5rem; //$general-padding;
		cursor: pointer;
		//background: map-get($grey, "lighten-5");
		//transition: background-color 1.2s ease-in-out;

		@include up($md) {
			gap: 0.25rem;
			//padding-left: 0; //$general-padding;
			//padding-right: 0; //$general-padding;
			//padding-right: 1rem; //$general-padding;
			background: unset; //map-get($grey, "lighten-5");
		}
	}

	&__link {
		position: relative;
		z-index: 1;
		flex-grow: 1; // on mobile the whole line = link

		//width: 10%;
		//max-width: calc(100% - 5rem);
		//height: 100%;
		//@include transition();

		/*@include up($md) {
			min-width: 3rem;
			flex-grow: 0; // on desktop the link is only the text part
			//padding: 0.25rem 0 0.25rem 0;
		}*/

		/*&:hover {
			color: $black !important;
			opacity: 1 !important;
		}*/
	}

	&__selector {
		width: 100%;
		height: 100%;
		padding: 8px 0 8px 0;
		display: inline-flex;
		align-items: flex-start;
		justify-content: space-between;

		@include up($md) {
			.tag {
				margin-top: 4px;
			}

			.v-icon {
				margin-top: 2px;
			}
		}
	}

	&__name {
		position: relative;
		top: -1px;
		font-size: $font-size-1;
		line-height: 24px;
		/*display: inline-flex;
		column-gap: 0.5rem;
		align-items: center;
		flex-wrap: wrap;*/
		//font-weight: 100;

		@include up($md) {
			line-height: 22px;
			font-size: $font-size-3;
		}

		i, .tag {
			margin-left: 8px;
		}

		&-text {
			@include transition();
		}
	}

	&__content {
		/*p {
			!*&:first-child {
				margin: 0;
			}*!
			margin: 0 0 4px 0 !important;
		}*/

		& + .context-task__files {
			margin: 1.5rem 0 0 0;
		}

		/*a {
			color: map-get($blue, "darken-1") !important;

			&:hover {
				color: map-get($blue, "darken-2") !important;
			}
		}*/
	}

	&__parent-title {
		display: flex;
		align-items: flex-start;
		gap: 0.5rem;

		.v-icon {
			margin: 0;
			//transform: rotate(90deg);
		}
	}

	&__file {
		cursor: pointer;
		background: map-get($grey, "lighten-4");
		padding: 8px;
		border-radius: 5px;
		@include transition();

		&:hover {
			color: map-get($blue, "lighten-1");

			.v-icon {
				color: map-get($blue, "lighten-1");
			}
		}

		&-image {
			display: flex;
			justify-content: center;
			align-items: center;
			@include transition();

			&:hover {
				opacity: $default-hover-opacity;
			}

			.v-image {
				width: 8vw;
				height: 6vh;
			}
		}
	}

	&__folder-link {
		@include passive-icon();
	}

	.assignee {
		z-index: 1;
		@include transition();
	}

	&__tools {
		/*position: absolute;
		z-index: 1;
		top: 16px;
		right: 8px;*/
		//min-width: 15%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		flex-shrink: 0;

		@include up($md) {
			gap: .5em;
		}
	}

	&__thumb {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 30px;
		height: 20px;
		border: 1px solid map-get($grey, "lighten-2");
		margin-left: .75rem;
		overflow: hidden;
		flex-shrink: 0;

		.v-image {
			width: 100%;
			height: 100%;
		}

		@include up($md) {
			margin-right: .75rem;
		}

		/*img {
			display: block;
			//max-width: 100%;
			max-height: 40px;
			object-fit: cover;
			margin: 0;
		}*/
	}

	&__swiped-tools {
		&.--left {
			position: absolute;
			left: 0;
			top: 0;
			width: 30vw;
			height: 100%;
			display: flex;
			justify-content: flex-start;
			padding-left: 3vw;
			align-items: center;
			background: map-get($grey, "darken-1");
			color: white;
		}

		&.--right {
			position: absolute;
			right: 0;
			top: 0;
			width: 30vw;
			height: 100%;
			//margin: 0 0.25rem 0 0.75rem;
			//display: none;
			display: flex;
			justify-content: flex-end;
			padding-right: 3vw;
			align-items: center;
			background: map-get($blue, "darken-1");
			color: white;
		}

		.v-icon {
			opacity: .4;
			color: white;
		}
	}

	.context-progress {
		position: absolute;
		left: 0;
		width: 200px;

		@include up($md) {
			@include transition();
			width: 200px;
		}
	}

	&__children {
		//border-top: 1px dotted map-get($grey, "lighten-1");
		//border-bottom: 1px dotted map-get($grey, "lighten-1");
		//background-color: map-get($grey, "lighten-3");
		padding: 0 0 1rem 0;
	}

	.--mt {
		margin-top: 5px;

		@include up($md) {
			margin-top: 6px;
		}
	}

	/*.tag-delayed {
		margin-top: 5px;
	}*/

	.__date {
		display: inline-block;
		margin-right: .75rem;
	}

	&__droppable-folder {
		flex: 1;
		//background: rgba(0, 0, 255, 0.05);

		/*&.--over {
			//background: rgba(0,0,255,0.05);
			&:after {
				//transform: translateY(-50%);
				background: map-get($blue, "lighten-1");
			}
		}*/
	}

	.draggable__handle {
		//display: none;
		left: .5rem;
	}

	/*&__scaffold-count {
		display: inline-block;
		min-width: 18px;
		margin-left: .5rem;
		padding: 0 5px;
		border-radius: 9px;
		text-align: center;
		color: map-get($grey, "darken-1");
		background: map-get($grey, "lighten-3");
	}*/
}
</style>
